// extracted by mini-css-extract-plugin
module.exports = {"header":"TextView_header__1i_bR","myMasonryGrid":"TextView_myMasonryGrid__ZEU4f","myMasonryGridColumn":"TextView_myMasonryGridColumn__OaKEr"};